import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

export const LOADER_EXECUTE_WITH_LOADER = 'loader/executeWithLoader';

export interface LoaderState {
  isLoading: boolean;
  loadingMessage: string;
}

export const state: LoaderState = {
  isLoading: false,
  loadingMessage: ''
};

export const getters: GetterTree<LoaderState, any> = {
  isLoading: () => state.isLoading,
  loadingMessage: () => state.loadingMessage
};

export const mutations: MutationTree<LoaderState> = {
  setLoading(_, value) {
    state.isLoading = value;
  }
};

export const actions: ActionTree<LoaderState, any> = {
  executeWithLoader: async ({ commit, dispatch }, { type, payload }) => {
    commit('setLoading', true);
    await dispatch(type, payload, { root: true });
    commit('setLoading', false);
  },
};

export const loader: Module<LoaderState, any> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
